import React, { Fragment } from 'react';
// this css style should be updated / fixed to not be inline next time
const legalStyle = {
  color: '#444444'
};

const LegalInformation = () => {
  return (
    <Fragment>
      <p className="byline _alignCenter _fontSize--small-mobileOnly _horizontalPadding--normal-mobileOnly">
        All financing applications are subject to First Circle's review. Please study the terms of our loan offer before signing the Disclosure Statement and the Loan Agreement.
      </p>
      <p className="byline _alignCenter _fontSize--small-mobileOnly">
        © 2020 First Circle Growth Finance Corp.
      </p>
      <p className="byline _alignCenter _fontSize--small-mobileOnly" style={legalStyle}>
        SEC Company Reg. No. CS201605477
        <br/>
        Certificate of Authority No. 1108
      </p>
    </Fragment>
  )
}

export default LegalInformation;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/BottomLegalInformation.js